import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class MapService {
	public markerLocationChanged$: EventEmitter<any>;
	public markerUpdated$: EventEmitter<any>;

	constructor() {
		this.markerUpdated$ = new EventEmitter<any>();
		this.markerLocationChanged$ = new EventEmitter<any>();
	}
}
